import { state } from '../state';
import { formatTime } from '../ui';
import { exportDocx } from './docx';
import { exportPdf } from './pdf';

export function getFormattedTranscript(includeTimestamps: boolean): string {
  return state.paragraphs
    .map((p) => {
      const time = includeTimestamps ? `[${formatTime(p.start)}] ` : '';
      const name = state.speakerMap[p.speaker] ?? `Speaker ${p.speaker}`;
      return `${time}${name}: ${p.text}`;
    })
    .join('\n\n');
}

export function exportTxt(includeTimestamps: boolean): void {
  const text = getFormattedTranscript(includeTimestamps);
  const blob = new Blob([text], { type: 'text/plain' });
  triggerDownload(blob, 'Transcripcion_Scribe.txt');
}

export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export { exportPdf, exportDocx };
